tinymce.PluginManager.add('dynamicanswer', function (editor) {
  const participantItems = editor.getParam('participant_details');
  const calculatedVariables = editor.getParam('calculated_variables');
  const modules = editor.getParam('modules');
  let moduleItems = editor.getParam('module_items');
  let studyType = editor.getParam('study_type');
  let graphField = editor.getParam('graph_field');
  let dialog = false;

  const getDialogConfigItem = (label, name, items) => ({ type: 'selectbox', label, name, items });

  const getDialogConfigItemsForModule = () => [
    getDialogConfigItem('Select a module first', 'module', modules),
    getDialogConfigItem('Select module item', 'module_item', moduleItems),
  ];

  function getDialogConfig() {
    return {
      title: 'Add module item answer',
      body: {
        type: 'panel',
        items: graphField
          ? getDialogConfigItemsForModule()
          : studyType === 'careercompass'
          ? [
              ...getDialogConfigItemsForModule(),
              getDialogConfigItem('Select calculated variable', 'calculated_variable', calculatedVariables),
            ]
          : [
              getDialogConfigItem('Select participant details', 'participant_detail', participantItems),
              ...getDialogConfigItemsForModule(),
              getDialogConfigItem('Select calculated variable', 'calculated_variable', calculatedVariables),
            ],
      },
      buttons: [
        {
          type: 'submit',
          text: 'OK',
          primary: true,
        },
        {
          type: 'cancel',
          text: 'CANCEL',
        },
      ],
      onChange: (dialog) => {
        const selectedModuleId = dialog.getData().module;
        if (selectedModuleId) {
          moduleItems = [{ text: '', value: '' }];
          const tempModuleItems = modules.find((module) => module.value === selectedModuleId.toString()).moduleItems;
          tempModuleItems.map((moduleItem) => {
            if (
              moduleItem.type === 'number' ||
              moduleItem.type === 'text' ||
              (moduleItem.type === 'special' && moduleItem.subType === 'image')
            ) {
              moduleItems.push({
                text: moduleItem.translations.find(
                  (translation) => translation.language === 'en' && translation.identifier === 'question'
                ).translation,
                value: moduleItem.id.toString(),
              });
            }
          });
          const answersBeforeRedial = dialog.getData();
          dialog.redial(getDialogConfig());
          dialog.setData(answersBeforeRedial);
        }
      },
      onSubmit: (dialog) => {
        editor.focus();
        const participantDynamicData = dialog.getData().participant_detail;
        const cvDynamicData = dialog.getData().calculated_variable;
        const moduleItemDynamicData = dialog.getData().module_item;
        if (participantDynamicData) {
          editor.insertContent(participantDynamicData);
        }
        if (moduleItemDynamicData) {
          editor.insertContent(`[item-${moduleItemDynamicData}]`);
        }
        if (cvDynamicData) {
          editor.insertContent(`[cv-${cvDynamicData}]`);
        }
        if (participantDynamicData || moduleItemDynamicData || cvDynamicData) {
          editor.fire('keyup');
          dialog.close();
        }
      },
    };
  }

  const openDialog = () => {
    dialog = editor.windowManager.open(getDialogConfig());
  };

  editor.ui.registry.addButton('dynamicAnswer', {
    title: 'Add dynamic text',
    text: 'Dynamic text',
    onAction: () => {
      openDialog();
    },
  });
});
